// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__250pW","inputWrap":"CustomTip_inputWrap__3_RYZ"};